import React from "react";
import Dashboard, { DashboardRootWrapper } from "views/Dashboard";
import { permission } from "utils/permissions";

const ArenaMemberDashboardView: React.FC = () => {
    return (
        <DashboardRootWrapper container wrap="nowrap">
            <Dashboard
                banners={[
                    {
                        title: "memberships",
                        breadcrumbs: "bannerMemberships",
                        image: `${process.env.PUBLIC_URL}/assets/images/representatives/arenaMemberMembershipAgreements.jpg`,
                        route: "memberships",
                        requiredPermissions: permission.MEMBERSHIPS
                    },
                    {
                        title: "subscriptions",
                        breadcrumbs: "bannerSubscriptions",
                        image: `${process.env.PUBLIC_URL}/assets/images/representatives/arenaMemberSubscriptions.jpg`,
                        route: "subscriptions",
                        requiredPermissions: permission.SUBSCRIPTIONS
                    },
                    {
                        title: "arenaOffices",
                        breadcrumbs: "bannerArenaOffices",
                        image: `${process.env.PUBLIC_URL}/assets/images/representatives/arenaMemberArenaOffices.jpg`,
                        route: "arena-offices",
                        requiredPermissions: permission.ARENA_OFFICE
                    },
                    {
                        title: "members",
                        breadcrumbs: "members",
                        image: `${process.env.PUBLIC_URL}/assets/images/representatives/arenaMemberUsers.jpg`,
                        route: "members",
                        requiredPermissions: permission.MEMBERS
                    }
                ]}
            />
        </DashboardRootWrapper>
    );
};

export default ArenaMemberDashboardView;
